type CountryOption = {
  iso: string;
  name: string;
};

type AddressCountryFields = {
  country?: string | null;
  country_code?: string | null;
};

export function createAddressCountryReset(
  countryCode: string,
  countryName: string,
) {
  return {
    country: countryName,
    country_code: countryCode,
    name: "",
    address1: "",
    address2: "",
    city: "",
    state: "",
    postal_code: "",
  };
}

export function resolveAddressCountryCode(
  address: AddressCountryFields,
  countries: readonly CountryOption[] | undefined,
) {
  if (address.country_code && !countries) {
    return address.country_code;
  }

  if (!countries) {
    return undefined;
  }

  const countryCode = countries.find(
    (country) => country.iso === address.country_code,
  )?.iso;

  if (countryCode || !address.country) {
    return countryCode;
  }

  return countries.find((country) => country.name === address.country)?.iso;
}

export function resolveCountryName(
  countries: readonly CountryOption[] | undefined,
  countryCode: string | null | undefined,
  fallback = "United States",
) {
  if (!countryCode) {
    return fallback;
  }

  return (
    countries?.find((country) => country.iso === countryCode)?.name ?? fallback
  );
}
